export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/cta-default-bg-43de918fccab6668d4d4bcadb434bf20.svg";